import { Component, input, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TruncateDirective } from 'shared';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';
import type { SidebarMenuChild, SidebarMenuItem } from './sidebar-menu.interfaces';

@Component({
  selector: 'ocp-sidebar-menu',
  imports: [TranslatePipe, TruncateDirective, ThemedIconComponent],
  templateUrl: './sidebar-menu.component.html',
  styleUrl: './sidebar-menu.component.scss',
})
export class SidebarMenuComponent {
  readonly items = input<SidebarMenuItem[]>([]);
  readonly showSeparator = input(true);
  readonly itemClicked = output<SidebarMenuItem>();
  readonly childClicked = output<SidebarMenuChild>();

  readonly expandedIds = signal<Set<string>>(new Set());

  protected isExpanded(item: SidebarMenuItem): boolean {
    if (item.expanded && !this.expandedIds().has('_collapsed_' + item.id)) {
      return true;
    }
    return this.expandedIds().has(item.id);
  }

  protected toggleExpand(item: SidebarMenuItem): void {
    if (!item.children?.length) {
      this.itemClicked.emit(item);
      return;
    }

    this.expandedIds.update(ids => {
      const next = new Set(ids);
      if (this.isExpanded(item)) {
        next.delete(item.id);
        if (item.expanded) {
          next.add('_collapsed_' + item.id);
        }
      } else {
        next.add(item.id);
        next.delete('_collapsed_' + item.id);
      }
      return next;
    });
  }

  protected onItemClick(item: SidebarMenuItem): void {
    if (item.children?.length) {
      this.toggleExpand(item);
    } else {
      this.itemClicked.emit(item);
    }
  }

  protected onChildClick(child: SidebarMenuChild): void {
    this.childClicked.emit(child);
  }
}
